import { useEffect, useState } from "react";
import api from "../services/api";
import DataTable from 'react-data-table-component';
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx'; // Importar la librería XLSX

const Informe = () => {
    const [informes, setInformes] = useState([]);
    const [botonGenerarInforme, setBotonGenerarInforme] = useState(0);
    const [patologias, setPatologias] = useState([]);
    const [paises, setPaises] = useState([]);
    const [patologiaSeleccionada, setPatologiaSeleccionada] = useState('');
    const [paisSeleccionado, setPaisSeleccionado] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [mensajeNoInformes, setMensajeNoInformes] = useState('');
    const [filterTrigger, setFilterTrigger] = useState(0); // Estado para controlar la actualización de los datos
    const navigate = useNavigate();

    // Obtener patologías y países al cargar el componente
    useEffect(() => {
        GetPatologias();
        GetPaises();
    }, []);

    // Ejecutar el filtro cuando los valores cambian
    useEffect(() => {
        leerDatosInforme();
    }, [filterTrigger]); // Solo se llama cuando filterTrigger cambia

    useEffect(() => {
        if (botonGenerarInforme > 0) {
            navigate("../generarInforme");
        }
    }, [botonGenerarInforme]);

    const GetPatologias = async () => {
        try {
            const response = await api.get(`/getPatologias`);
            setPatologias(response.data);
        } catch (error) {
            console.error("Error al obtener patologías:", error);
        }
    };

    const GetPaises = async () => {
        try {
            const response = await api.get(`/getPaises`);
            setPaises(response.data);
        } catch (error) {
            console.error("Error al obtener países:", error);
        }
    };

    const leerDatosInforme = async () => {
        try {
            const response = await api.get(`/leerDatosInforme`, {
                params: { 
                    patologia: patologiaSeleccionada,
                    pais: paisSeleccionado,
                    fechaInicio,
                    fechaFin
                }
            });

            if (response.status === 200) {
                setInformes(response.data.data || response.data);
                setMensajeNoInformes('');
            } else {
                setInformes([]);
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setInformes([]);
                setMensajeNoInformes('No se encontraron informes para los criterios proporcionados.');
            } else {
                console.error("Error al obtener los informes guardados:", error);
                setMensajeNoInformes('Error al obtener los informes.');
            }
        }
    };

    // Función para manejar el click en el botón "Filtrar" y actualizar los datos
    const handleFiltrar = () => {
        if (new Date(fechaInicio) > new Date(fechaFin)) {
            alert("La fecha de inicio no puede ser mayor que la fecha de final.");
            return;
        }
        setFilterTrigger(filterTrigger + 1); // Forzar que se recarguen los datos
    };
    
    const handleGenerarInforme = () => {
        const confirmacion = window.confirm("¿Estás seguro de que quieres generar un nuevo informe?");
        if (confirmacion) {
            setBotonGenerarInforme(1);
        }
    };

    // Función para exportar los datos a Excel
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(informes); // Convertir informes a hoja de Excel
        const workbook = XLSX.utils.book_new(); // Crear un nuevo libro
        XLSX.utils.book_append_sheet(workbook, worksheet, "Informes"); // Añadir la hoja al libro
        XLSX.writeFile(workbook, "informes.xlsx"); // Guardar el archivo
    };

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            width: '70px'
        },
        {
            name: 'Patología',
            selector: row => row.patologia,
            sortable: true,
        },
        {
            name: 'País',
            selector: row => row.pais,
            sortable: true,
        },
        {
            name: 'Total Casos',
            selector: row => row.totalCasos,
            sortable: true,
        },
        {
            name: 'Total Contactos',
            selector: row => row.totalContactos,
            sortable: true,
        },
        {
            name: 'Fecha de Creación',
            selector: row => new Date(row.fechaCreacion).toLocaleString(),
            sortable: true,
        },
    ];

    const today = new Date().toISOString().split('T')[0];

    return (
        <div style={styles.container}>
            <div style={styles.formGroup}>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Patología</label>
                    <select
                        value={patologiaSeleccionada}
                        onChange={(e) => setPatologiaSeleccionada(e.target.value)}
                        style={styles.select}
                    >
                        <option value="">Todas las Patologías</option>
                        {patologias.map((patologia) => (
                            <option key={patologia.IdPatologia} value={patologia.Nombre}>
                                {patologia.Nombre}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={styles.inputGroup}>
                    <label style={styles.label}>País</label>
                    <select
                        value={paisSeleccionado}
                        onChange={(e) => setPaisSeleccionado(e.target.value)}
                        style={styles.select}
                    >
                        <option value="">Todos los Países</option>
                        {paises.map((pais) => (
                            <option key={pais.IdPais} value={pais.Nombre}>
                                {pais.Nombre}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={styles.inputGroup}>
                    <label style={styles.label}>Fecha de Inicio</label>
                    <input 
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                        max={today}
                        style={styles.dateInput}
                    />
                </div>

                <div style={styles.inputGroup}>
                    <label style={styles.label}>Fecha de Fin</label>
                    <input 
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                        max={today}
                        style={styles.dateInput}
                    />
                </div>

                <button
                    style={styles.button}
                    onClick={handleGenerarInforme}
                >
                    Generar nuevo Informe
                </button>

                {/* Botón Filtrar */}
                <button
                    style={styles.buttonFiltrar}
                    onClick={handleFiltrar}
                >
                    Filtrar
                </button>

                {/* Botón Exportar a Excel con imagen */}
                <button
                    style={styles.button}
                    onClick={exportToExcel}
                >
                    <img src="/imagenes/b60c442e6dd69356b90b9e5bec23cc99.png" alt="Exportar a Excel" style={styles.icon} />
                    
                 
                </button>
            </div>

            <h2>Listado de Informes</h2>

            {mensajeNoInformes ? (
                <div style={styles.noData}>
                    {mensajeNoInformes}
                </div>
            ) : (
                <DataTable
                    columns={columns}
                    data={informes}
                    pagination
                    highlightOnHover
                    noDataComponent="No hay informes disponibles."
                />
            )}

            <div style={styles.verificacion}>
                Verificación:
                <br />
                Total de informes: {informes.length}
            </div>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: 'Arial, sans-serif',
        margin: '20px',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    },
    formGroup: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px',
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: '10px',
    },
    label: {
        fontWeight: 'bold',
        marginBottom: '5px',
    },
    select: {
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        width: '150px',
    },
    dateInput: {
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
    button: {
        padding: '4px 8px',
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '9px',
        cursor: 'pointer',
    },
    buttonFiltrar: {
        padding: '10px 20px',
        backgroundColor: '#2196F3',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    noData: {
        padding: '10px',
        textAlign: 'center',
        color: 'red',
    },
    verificacion: {
        marginTop: '20px',
    },
    icon: {
        width: '40px',  // Cambiado de 16px a 32px
        height: '35px', // Cambiado de 16px a 32px
        marginRight: '6px',
    }
};

export default Informe;

